module.exports = __webpack_public_path__ + "media/src/images/voucher_card-2e8098a8711aaab8155a37afdad78691.png";